import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TemaService } from 'src/app/services/tema.services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dialog-confirmacion',
  templateUrl: './dialog-confirmacion.component.html',
  styleUrls: ['./dialog-confirmacion.component.scss']
})
export class DialogConfirmacionComponent {
  public isDark: boolean = false;
  private temaSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      titulo: string,
      mensaje: string,
      botonConfirmar: string,
      botonCancelar: string
    },
    private temaService: TemaService
  ) { 
    this.temaSubscription = this.temaService.valDarkTheme.subscribe(dark => {
      this.isDark = dark;
    });
  }

  ngOnDestroy(): void {
    if (this.temaSubscription) {
      this.temaSubscription.unsubscribe();
    }
  }

  onConfirmar(): void {
    this.dialogRef.close(true);
  }

  onCancelar(): void {
    this.dialogRef.close(false);
  }
}